module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_8011.7ffd38c9.png";